import React, { useEffect } from 'react';
import { isCognitoConfigured } from '../config/cognito';
import { cognitoAuthService } from '../services/cognitoAuth.service';

/**
 * Listens for spinora-logout; clears token, signs out of Cognito, and redirects to home.
 * Uses window.location.href (full reload) instead of navigate so logout works reliably
 * after long idle—when the app may be in a bad state (frozen tab, stale chunks).
 */
export const LogoutHandler: React.FC = () => {
  useEffect(() => {
    const handler = () => {
      localStorage.removeItem('authToken');
      if (isCognitoConfigured()) {
        try {
          cognitoAuthService.signOut();
        } catch {
          /* ignore if session already invalid */
        }
      }
      window.location.href = '/';
    };
    window.addEventListener('spinora-logout', handler);
    return () => window.removeEventListener('spinora-logout', handler);
  }, []);

  return null;
};
